import { httpClientVendasCoreBff } from 'vendas-core/shared/services'

import { httpWithChallenge } from '~/domains/platform/infra/http/http-with-challenge'

export type ToggleAffiliationRequest = {
  affiliationId: string
  active: boolean
}

type UseToggleAffiliationParams = {
  paymentProfileId: string
}

export function useToggleAffiliation({ paymentProfileId }: UseToggleAffiliationParams) {
  return ({ affiliationId, active }: ToggleAffiliationRequest) =>
    httpWithChallenge({
      config: {
        url: `/v1/payment-profile/${paymentProfileId}/affiliations/${affiliationId}`,
        method: 'PATCH',
        data: { is_enabled: active }
      },
      client: httpClientVendasCoreBff
    })
}
